import { useMigrateTranscriptDefaultTabToNote } from '@/features/migrations/hooks/useMigrateTranscriptDefaultTabToNote';

export function Migrations() {
  useMigrateTranscriptDefaultTabToNote();
  return null;
}
